/* Bold Grip Socks — promo slideshow (sections/promo-trio-hero.liquid with blocks).
   Fades between stacked slides; dots, arrows, swipe, pause button.
   Autoplay pauses on hover, focus, touch, hidden tab, off-screen and for reduced motion. */
(function () {
  function init(root) {
    if (root.__pslides) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    if (slides.length < 2) return;
    root.__pslides = true;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pslides-dot]'));
    var prev = root.querySelector('[data-pslides-prev]');
    var next = root.querySelector('[data-pslides-next]');
    var pauseBtn = root.querySelector('[data-pslides-pause]');
    var delay = parseInt(root.getAttribute('data-delay'), 10) || 7000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, timer = null, paused = !!reduce, holding = false, visible = true;

    if (reduce && pauseBtn) setPausedUi(true);

    function go(n, byUser) {
      n = (n + slides.length) % slides.length;
      slides.forEach(function (s, j) {
        var on = j === n;
        s.classList.toggle('is-active', on);
        if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); }
        else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
      });
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === n ? 'true' : 'false'); });
      root.classList.toggle('is-night', slides[n].classList.contains('ptrio--night'));
      i = n;
      if (byUser) start();
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (!paused && !holding && visible && !document.hidden) timer = setInterval(function () { go(i + 1); }, delay);
    }
    function setPausedUi(p) {
      if (!pauseBtn) return;
      pauseBtn.setAttribute('aria-pressed', p ? 'true' : 'false');
      pauseBtn.setAttribute('aria-label', p ? 'Play slideshow' : 'Pause slideshow');
    }
    root.__go = function (n) { go(n); stop(); };

    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j, true); }); });
    if (prev) prev.addEventListener('click', function () { go(i - 1, true); });
    if (next) next.addEventListener('click', function () { go(i + 1, true); });
    if (pauseBtn) pauseBtn.addEventListener('click', function () {
      paused = !paused; setPausedUi(paused); if (paused) stop(); else start();
    });

    root.addEventListener('mouseenter', function () { holding = true; stop(); });
    root.addEventListener('mouseleave', function () { holding = false; start(); });
    root.addEventListener('focusin', function () { holding = true; stop(); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { holding = false; start(); } });

    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) go(dx < 0 ? i + 1 : i - 1, true);
      else start();
    }, { passive: true });

    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { visible = en.isIntersecting; if (visible) start(); else stop(); });
      }, { threshold: 0.35 }).observe(root);
    }

    go(0);
    start();
  }

  function boot() { document.querySelectorAll('[data-pslides]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-slide]');
    var root = slide && slide.closest('[data-pslides]');
    if (root && root.__go) root.__go(parseInt(slide.getAttribute('data-slide'), 10) - 1);
  });
})();
